import { memo } from 'react';

import { Form } from '@components/form';

import { useTranslatedFieldText } from './locale';
import { FileField, FileMultiField } from './types';

export const FileInput = memo<{ field: FileField }>(({ field }) => {
  return <Form.FileField label={useTranslatedFieldText(field.text)} {...field} />;
});

export const FileMultiInput = memo<{ field: FileMultiField }>(({ field }) => {
  return <Form.FileFieldMulti label={useTranslatedFieldText(field.text)} {...field} />;
});
